import React, { useState } from 'react';
import classes from "./ServiceCard.module.css";
import { GoArrowRight } from "react-icons/go";
import { Modal } from 'react-bootstrap';
import Button from '../../components/Button';

export default function ServiceCard({ data }) {
  const [showModal, setShowModal] = useState(false);

  const handleModalOpen = () => setShowModal(true);
  const handleModalClose = () => setShowModal(false);

  return (
    <>
      <div className={classes.mainDiv}>
        <div className={classes.imageDiv}>
          <img src={data?.image} alt="img" />
        </div>
        <p className={`f-26 fw-600 ${classes.title}`}>{data?.title}</p>
        <p className={`f-15 fw-400`}>{data?.content}</p>
        <p
          className="f-17 fw-400"
          style={{ cursor: 'pointer', color: 'var(--primary-color)' }}
          onClick={handleModalOpen}
        >
          Read More <GoArrowRight size={20} />
        </p>
      </div>

      {/* Modal */}
      <Modal 
        show={showModal} 
        onHide={handleModalClose} 
        size="lg" 
        centered
        dialogClassName="custom-modal"
      >
        <Modal.Body style={{ padding: '1.5rem' }}>
          <h4 className="f-30 fw-600 mb-4">{data?.title}</h4>

        

          <div
            className="f-18 fw-400"
            dangerouslySetInnerHTML={{ __html: data?.fullContent || data?.content }}
          />
        </Modal.Body>
        <Modal.Footer style={{ borderTop: 'none', justifyContent: 'center', padding: '1rem 0' }}>
          <Button label="Close" variant="outlined" onClick={handleModalClose} />
        </Modal.Footer>
      </Modal>
    </>
  );
}

